enum InvoiceStatusState {
  Draft = 0,
  Todo = 7,
  Wip = 10,
  Blocked = -1,
  Canceled = -100,
  Completed = 20,
}

export function isEditable(state: InvoiceStatusState) {
  return (
    state === InvoiceStatusState.Blocked ||
    state === InvoiceStatusState.Canceled
  );
}

export default InvoiceStatusState;
